import {
  Building2,
  ShieldCheck,
  Users,
  GitBranch,
  UsersRound,
  ClipboardList,
  Search,
  Grid3X3,
  Gauge,
  Shield,
  Activity,
  FileType,
  Layers,
  Boxes,
  FolderTree,
  Server,
  Truck,
  ScrollText,
  Globe2,
  Handshake,
  FileText,
  Megaphone,
  Radar,
  Bug,
  AlertTriangle,
  Route,
  ShieldHalf,
  ListChecks,
  Target,
  Building,
  Library,
  Timer,
  Database,
  KeyRound,
  HeartPulse,
  Map,
  Dumbbell,
  Ticket,
  Mail,
  Plug,
  GraduationCap,
  BookOpen,
  Wand2,
} from "lucide-react";

/** Structural SoT for Setup Roadmap — copy lives in setupGuide i18n namespace. */
export const SETUP_ROADMAP_PHASES = [
  {
    id: "foundation",
    tier: "required",
    icon: Building2,
    wizardPath: "/setup",
    steps: [
      { id: "units", path: "/definitions/organization/units", icon: Building2 },
      { id: "roles", path: "/user-operations/role-management", icon: ShieldCheck },
      { id: "users", path: "/user-operations/user-management", icon: Users },
    ],
  },
  {
    id: "organization",
    tier: "recommended",
    icon: GitBranch,
    steps: [
      { id: "processes", path: "/definitions/organization/process", icon: GitBranch },
      { id: "teams", path: "/definitions/organization/team", icon: UsersRound },
      { id: "duties", path: "/definitions/organization/duty-definitions", icon: ClipboardList },
      { id: "rootCause", path: "/definitions/organization/root-cause", icon: Search },
    ],
  },
  {
    id: "scales",
    tier: "recommended",
    icon: Grid3X3,
    steps: [
      { id: "riskMatrix", path: "/definitions/scale/risk-assessment-matrix", icon: Grid3X3 },
      { id: "impactProbability", path: "/definitions/scale/impact", icon: Gauge },
      { id: "cia", path: "/definitions/scale/cia-matrix", icon: Shield },
      { id: "biaScale", path: "/definitions/scale/bia-impact-scale", icon: Activity },
    ],
  },
  {
    id: "documents",
    tier: "recommended",
    icon: FileType,
    steps: [
      { id: "documentTypes", path: "/definitions/document/document-type", icon: FileType },
      { id: "classification", path: "/definitions/document/classification", icon: Layers },
    ],
  },
  {
    id: "inventory",
    tier: "recommended",
    icon: Boxes,
    steps: [
      { id: "assetGroup", path: "/asset-inventory-management/asset-group", icon: FolderTree },
      { id: "assetCategory", path: "/asset-inventory-management/asset-category", icon: Layers },
      { id: "assets", path: "/asset-inventory-management/assets", icon: Server },
      { id: "vendors", path: "/vendor-management/vendors", icon: Truck },
      { id: "licenses", path: "/asset-inventory-management/license-management", icon: ScrollText },
    ],
  },
  {
    id: "context",
    tier: "module",
    icon: Globe2,
    steps: [
      { id: "context", path: "/context-management/context", icon: Globe2 },
      { id: "interestedParties", path: "/context-management/interested-parties", icon: Handshake },
      { id: "scope", path: "/context-management/scope-document", icon: FileText },
      { id: "communication", path: "/context-management/communication", icon: Megaphone },
    ],
  },
  {
    id: "riskControls",
    tier: "module",
    icon: AlertTriangle,
    steps: [
      { id: "threats", path: "/isms-controls/threat-intelligence", icon: Radar },
      { id: "vulnerabilities", path: "/isms-controls/vulnerability", icon: Bug },
      { id: "riskRegister", path: "/risk-management/risk-register", icon: AlertTriangle },
      { id: "riskTreatment", path: "/risk-management/risk-treatment", icon: Route },
      { id: "controls", path: "/isms-controls/control", icon: ShieldHalf },
      { id: "soa", path: "/isms-controls/soa", icon: ListChecks },
      { id: "objectives", path: "/isms-controls/objective", icon: Target },
    ],
  },
  {
    id: "privacy",
    tier: "module",
    icon: Database,
    steps: [
      { id: "kvkkCompany", path: "/definitions/kvkk/company", icon: Building },
      { id: "kvkkCatalogs", path: "/definitions/kvkk", icon: Library },
      { id: "retention", path: "/definitions/privacy/retention-periods", icon: Timer },
      { id: "pdInventory", path: "/asset-inventory-management/pd-inventory", icon: Database },
      { id: "consent", path: "/definitions/obtaining-explicit-consent/method", icon: KeyRound },
    ],
  },
  {
    id: "bcm",
    tier: "module",
    icon: HeartPulse,
    steps: [
      { id: "bia", path: "/bcm/bia", icon: HeartPulse },
      { id: "bcp", path: "/bcm/bcp", icon: Map },
      { id: "exercises", path: "/bcm/exercises", icon: Dumbbell },
    ],
  },
  {
    id: "operations",
    tier: "module",
    icon: Wand2,
    steps: [
      { id: "ticketing", path: "/ticketing/settings", icon: Ticket },
      { id: "mailTemplates", path: "/definitions/organization/mail-template", icon: Mail },
      { id: "integrations", path: "/definitions/integrations/connectors", icon: Plug },
      { id: "training", path: "/isms-controls/training/list", icon: GraduationCap },
      { id: "about", path: "/user-manual/about-sgrc", icon: BookOpen },
    ],
  },
];

/** Calm Setup Roadmap chrome: cyan icons, blue tier chips + progress, light-gray borders, neutral text. */
export const SETUP_UI = {
  border: "border-neutral-200",
  borderSoft: "border-neutral-100",
  /** ZORUNLU / ÖNERİLEN / MODÜLE BAĞLI */
  chip: "bg-blue-50 text-blue-700 border-blue-200",
  /** Phase / step counts, step index */
  metaChip: "bg-white text-foreground/70 border-neutral-200",
  icon: "bg-white text-cyan-600 border-neutral-200",
  box: "rounded-xl border border-neutral-200 bg-white",
  boxTitle: "text-foreground/70",
  progressTrack: "bg-blue-100",
  progressBar: "bg-blue-500",
};

